'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/ref.js
// module id = 1375
// module chunks = 1